import React, { useRef } from "react";
import "./Join.css";
import emailjs from "@emailjs/browser";

const Join = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_fits10b",
        "template_d2vjprt",
        form.current,
        "ZG1ABvqBgv9swIMND"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div className="Join" id="join-us">
      <div className="left-j">
        <hr />
        <div>
          <span className="stroke-text">PRONTO</span>
          <span>PARA EVOLUIR</span>
        </div>
        <div>
          <span>SEU SHAPE</span>
          <span className="stroke-text">COM A GENTE?</span>
        </div>
      </div>
      <div className="right-j">
        <form ref={form} className="email-container" onSubmit={sendEmail}>
          <input
            type="email"
            name="user_email"
            placeholder="Digite seu endereço e-mail"
          />
          <button className="btn btn-j">Matricule-se</button>
        </form>
      </div>
    </div>
  );
};

export default Join;
